import { Component, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef,  MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import {  MatAutocomplete } from '@angular/material/autocomplete';
import { NotificationService } from 'src/app/shared/notification.service';
import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { SystemService } from '../../../services/system.service';


@Component({
  selector: 'task-detail-popup',
  templateUrl: 'task-detail-popup.html',
  styleUrls: ['task-detail-popup.css']

})
export class TaskDetailPopup {

  editable = false;
  siteId: string;


  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  groupCtrl = new UntypedFormControl('');
  filterString: Observable<any>;
  filterGroups$: Observable<any>;

  groups$ = new Observable();

  userAddedGroups = []
  @ViewChild('groupInput',{static:false}) groupInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto',{static:false}) matAutocomplete: MatAutocomplete;
  constructor(
    public dialogRef: MatDialogRef<TaskDetailPopup>,
    private notifierService: NotificationService,
    private systemService: SystemService,
    @Inject(MAT_DIALOG_DATA) public data) {


  }
  updateCategory(data) {
    console.log(this.data)
    let obj = {
      renewalMonthly: false
    }
    // Credit renewals are always monthly. For other tasks the select gives the
    // string "true"/"false", but an untouched select still holds the boolean.
    obj.renewalMonthly = this.isCreditRenew()
      || data.renewalMonthly === true || data.renewalMonthly == "true";

    if (obj.renewalMonthly) {
      obj['performAt'] = moment().endOf('month').hour(Number(data.setHour)).minute(data.setMinutes).unix();
    } else {
      obj['performAt'] = moment().hour(Number(data.setHour)).minute(data.setMinutes).unix();
    }


    this.systemService.updateTask(this.data.dbid, obj);
    this.dialogRef.close()
  }

  isCreditRenew() {
    return /^creditRenew/.test(this.data?.worker || '');
  }

  onNoClick(): void {
    this.dialogRef.close();
  }




  runnow(data) {
    
    let obj = {}
    obj['performAt'] = moment().unix();
    obj['status'] = "scheduled";


    this.systemService.updateTask(this.data.dbid, obj);
    this.dialogRef.close()
  }

}